var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings content"},[_c('h2',[_vm._v(_vm._s(_vm.$text['settings']['settings']))]),_c('section'),_c('section')])}
var staticRenderFns = []

export { render, staticRenderFns }